// extracted by mini-css-extract-plugin
export default {"popupBox":"PopupSetupIntent_popupBox__OhBiZ","popupBox__box":"PopupSetupIntent_popupBox__box__E+mDQ"};